import { skipToken } from '@reduxjs/toolkit/query';

import {
    type GetToursParams,
    useCreateTourMutation,
    useDeleteTourMutation,
    useDownloadTourDocumentArchiveMutation,
    useDuplicateTourMutation,
    useGetTourDocumentArchiveJobQuery,
    useGetTourQuery,
    useGetToursQuery as useGetToursV2Query,
    useLazyGetTourDocumentArchiveJobQuery,
    useStartTourDocumentArchiveJobMutation,
    useUpdateTourMutation,
} from '#api/tourApi.slice.ts';
import { type RTKQueryOptions, withSkip } from '#api-bridge/utils/rktQuery.utils.ts';

export const useGetTour = (tourId: string | typeof skipToken, options?: RTKQueryOptions) => {
    const isSkipped = tourId === skipToken;
    const resolvedId = isSkipped ? '' : tourId;
    return useGetTourQuery(resolvedId, withSkip(options, isSkipped));
};

export const useGetToursQuery = (params?: GetToursParams, options?: RTKQueryOptions) =>
    useGetToursV2Query(params, options);

export {
    useCreateTourMutation,
    useDeleteTourMutation,
    useDownloadTourDocumentArchiveMutation,
    useDuplicateTourMutation,
    useGetTourDocumentArchiveJobQuery,
    useLazyGetTourDocumentArchiveJobQuery,
    useUpdateTourMutation,
    useStartTourDocumentArchiveJobMutation,
};
